import React from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import PropTypes from 'prop-types'
export class Confirm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isOpened: props.visible,
    }
    this.onButtonClick = this.onButtonClick.bind(this)
    this.onClose = this.onClose.bind(this)
    this.onConfirm = this.onConfirm.bind(this)
  }
  onButtonClick() {
    if (!this.state.isOpened) {
      this.setState({
        isOpened: true,
      })
    }
  }
  onClose(event) {
    if (event) {
      event.stopPropagation()
    }
    this.setState({
      isOpened: false,
    })
    if (typeof this.props.onClose === 'function') {
      this.props.onClose()
    }
  }
  onConfirm(event) {
    event.stopPropagation()
    this.setState({
      isOpened: false,
    })
    if (this.props.onConfirm) {
      this.props.onConfirm()
    }
  }
  render() {
    const cancelButton = this.props.showCancelButton ? (
      <ReactBootstrap.Button variant="outline-dark" onClick={this.onClose}>
        {this.props.cancelText}
      </ReactBootstrap.Button>
    ) : null
    const modal = (
      <ReactBootstrap.Modal
        show={this.state.isOpened}
        onHide={this.onClose}
        className={this.props.className}
        dialogClassName={this.props.dialogClassName}
        keyboard={this.props.keyboard}
        backdrop={this.props.backdrop}
        enforceFocus={this.props.enforceFocus}
      >
        <ReactBootstrap.Modal.Header>
          <ReactBootstrap.Modal.Title>
            {this.props.title}
          </ReactBootstrap.Modal.Title>
        </ReactBootstrap.Modal.Header>
        <ReactBootstrap.Modal.Body>{this.props.body}</ReactBootstrap.Modal.Body>
        <ReactBootstrap.Modal.Footer>
          {cancelButton}
          <ReactBootstrap.Button variant="dark" onClick={this.onConfirm}>
            {this.props.confirmText}
          </ReactBootstrap.Button>
        </ReactBootstrap.Modal.Footer>
      </ReactBootstrap.Modal>
    )
    let content
    if (this.props.children) {
      const btn = React.Children.only(this.props.children)
      content = React.cloneElement(
        btn,
        {
          onClick: (e) => {
            e.stopPropagation()
            this.onButtonClick()
          },
          style: this.props.style,
        },
        btn.props.children,
        modal
      )
    } else {
      content = (
        <ReactBootstrap.Button
          onClick={this.onButtonClick}
          className="btn-block"
          variant="outline-dark"
          size="sm"
        >
          {this.props.buttonText}
          {modal}
        </ReactBootstrap.Button>
      )
    }
    return content
  }
}
Confirm.propTypes = {
  body: PropTypes.node.isRequired,
  buttonText: PropTypes.node,
  cancelText: PropTypes.node,
  className: PropTypes.string,
  confirmBSStyle: PropTypes.string,
  confirmText: PropTypes.node,
  dialogClassName: PropTypes.string,
  keyboard: PropTypes.bool,
  backdrop: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  enforceFocus: PropTypes.bool,
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  showCancelButton: PropTypes.bool.isRequired,
  title: PropTypes.node.isRequired,
  visible: PropTypes.bool,
}
Confirm.defaultProps = {
  cancelText: 'Cancel',
  confirmText: 'Confirm',
  confirmBSStyle: 'dark',
  showCancelButton: true,
  keyboard: true,
  backdrop: true,
  enforceFocus: true,
}
